import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '@shared-configs/app-config';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { ResponseModel } from '@global-models/Response/ResponseModel';
import { TokenResponseModel } from '@auth-models/Response/TokenResponseModel';

@Injectable()
export class ApiSendService {
  private httpOption;
  private dashboardToken = JSON.parse(
    localStorage.getItem('DashboardToken')
  ) as TokenResponseModel;

  constructor(private _http: HttpClient) {
    this.httpOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  private TokenControl(result: ResponseModel): void {
    if (result.RefreshToken) {
      this.dashboardToken = JSON.parse(
        localStorage.getItem('DashboardToken')
      ) as TokenResponseModel;
      this.dashboardToken.Token = result.RefreshToken;
      localStorage.setItem(
        'DashboardToken',
        JSON.stringify(this.dashboardToken)
      );
    }
  }

  private GetApiUrl(apienum: number): string {
    let url: string;

    switch (apienum) {
      case ApiUrlEnum.BackOffice:
        url = AppConfig.backOfficeUrl;
        break;
      case ApiUrlEnum.Ticari:
        url = AppConfig.ticariUrl;
        break;
      case ApiUrlEnum.Smm:
        url = AppConfig.smmUrl;
        break;
      case ApiUrlEnum.Emm:
        url = AppConfig.mmUrl;
        break;
      case ApiUrlEnum.Ticket:
        url = AppConfig.ticketUrl;
        break;
      case ApiUrlEnum.Bill:
        url = AppConfig.billUrl
        break;
      case ApiUrlEnum.ExpenseVoucher:
        url = AppConfig.expenseVoucherUrl;
        break;

    }

    return url;
  }

  private GetAuthorizationHttpOption() {
    let httpOptionAuthorization = null;
    if (localStorage.length > 0) {
      this.dashboardToken = JSON.parse(
        localStorage.getItem('DashboardToken')
      ) as TokenResponseModel;
      if (this.dashboardToken !== null && this.dashboardToken !== undefined) {
        httpOptionAuthorization = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, OPTIONS',
            vbtauthorization: this.dashboardToken.Token,
          }),
        };
        return httpOptionAuthorization;
      } else {
        return this.httpOption;
      }
    } else {
      return this.httpOption;
    }
  }

  public async PostAuthorization(apienum: number, link: string, model: any) {
    const postUri = this.GetApiUrl(apienum) + link;
    const httpAuthorization = await this.GetAuthorizationHttpOption();

    return await this._http
      .post(postUri, JSON.stringify(model), httpAuthorization)
      .toPromise()
      .then((result) => {
        if (link.indexOf('LogOut') < 0) {
          const responseModel = (result ||
            new ResponseModel()) as ResponseModel;
          this.TokenControl(responseModel);
          return responseModel.Data;
        }
        return result;
      });
  }

  public async GetAuthorization(apienum: number, link: string) {
    const getUri = this.GetApiUrl(apienum) + link;
    const httpAuthorization = await this.GetAuthorizationHttpOption();

    return await this._http
      .get(getUri, httpAuthorization)
      .toPromise()
      .then((result) => {
        const responseModel = (result || new ResponseModel()) as ResponseModel;

        this.TokenControl(responseModel);
        return responseModel.Data;
      });
  }

  public GetAuthorizationNotPromise(apienum: number, link: string) {
    const getUri = this.GetApiUrl(apienum) + link;
    const httpAuthorization = this.GetAuthorizationHttpOption();

    return this._http.get(getUri, httpAuthorization);
  }

  public PostAuthorizationNotPromise(
    apienum: number,
    link: string,
    model: any
  ) {
    const postUri = this.GetApiUrl(apienum) + link;
    const httpAuthorization = this.GetAuthorizationHttpOption();

    return this._http.post(postUri, JSON.stringify(model), httpAuthorization);
  }

  public async Post(apienum: number, link: string, model: any) {
    return await this._http
      .post(
        this.GetApiUrl(apienum) + link,
        JSON.stringify(model),
        this.httpOption
      )
      .toPromise()
      .then((result) => {
        return result;
      });
  }

  public async Get(apienum: number, link: string) {
    const uri = this.GetApiUrl(apienum) + link;

    return await this._http
      .get(uri, this.httpOption)
      .toPromise()
      .then((result) => {
        return result;
      });
  }
}
